<div
  *ngIf="
    loggedUserRoleId == 1 || loggedUserRoleId == 2 || loggedUserRoleId == 3
  "
  (click)="openAdminHelpdeskModal(false)"
>
  Selected User: {{ loggedUser?.firstName }} {{ loggedUser?.lastName }}
</div>
<section class="container-fluid h-100" style="flex-grow: 1">
  <div class="row h-100">
    <div class="col-md-12 h-100 ps-0">
      <!-- <app-tour-dashboard></app-tour-dashboard> -->
      <router-outlet></router-outlet>
    </div>
  </div>
</section>
